import * as React from "react";
const SvgGallery = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	id: "gallery_svg__Layer_1",
	x: 0,
	y: 0,
	viewBox: "0 0 46.3 44.8",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { id: "gallery_svg__Layer_2_2_" }, /* @__PURE__ */ React.createElement("g", { id: "gallery_svg__Layer_1-2_1_" }, /* @__PURE__ */ React.createElement("path", {
	d: "M10.1 5.2H21v15.1H6v-11c0-2.2 1.8-4.1 4.1-4.1M25.7 5.2h11.1c2.2 0 3.9 1.7 3.9 3.9v11.1h-15zM6 24.8h15v15.1H10c-2.2 0-4-1.8-4-4zM25.7 24.8h15.1V36c0 2.1-1.7 3.8-3.8 3.8H25.7z",
	style: { fill: "currentColor" }
}))));
export default SvgGallery;
